import React from 'react';
import { HashLink } from 'react-router-hash-link';
const Cta = () => (
    <section aria-labelledby="project-cta-title" className="bg-blue-900 text-white">
        <div className="mx-auto max-w-6xl px-6 py-16 sm:px-8 lg:flex lg:items-center lg:justify-between lg:gap-12">
            <div className="max-w-3xl">
                <h2 id="project-cta-title" className="text-3xl font-bold">Bring AI into your workflow</h2>
                <p className="mt-4 text-lg leading-relaxed text-blue-100">Tell us what your users need to create, understand, or accomplish. We'll help connect the right speech, visual, and language capabilities with your application.</p>
            </div>
            <HashLink to="/contact#contact" className="mt-6 inline-flex shrink-0 items-center justify-center rounded-xl bg-white px-6 py-3 font-semibold text-blue-900 hover:bg-blue-50 lg:mt-0">Discuss your project <span className="ml-2" aria-hidden="true">→</span></HashLink>
        </div>
    </section>
);
export default Cta;
